import React from 'react';

interface PlaceholderImageProps {
  width: number;
  height: number;
  text?: string;
}

const PlaceholderImage: React.FC<PlaceholderImageProps> = ({ width, height, text }) => {
  // Generate a random background color
  const getRandomColor = () => {
    const colors = ['4F46E5', '7C3AED', '0EA5E9', '0891B2', '059669'];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const bgColor = getRandomColor();
  const displayText = text || `${width}x${height}`;
  
  // Create responsive placeholder that maintains aspect ratio
  return (
    <div 
      className="w-full h-full flex items-center justify-center" 
      style={{ 
        backgroundColor: `#${bgColor}`,
        color: 'white',
        fontSize: Math.min(width, height) / 10,
        fontWeight: 'bold',
        aspectRatio: `${width} / ${height}`,
      }}
    >
      {displayText}
    </div>
  );
};

export default PlaceholderImage;